import {DeepPartial} from 'utility-types';

import {GetDirectSaleVariantResponse} from '@dms/api/warehouse';
import {decimalValueToPercentage} from '@dms/settings/shared';

import {Nullish} from 'shared/web';

import {WarehouseDirectSaleVariantsDetailFormSchemaType} from '../types/WarehouseDirectSaleVariantsDetailFormSchema';

type GeneralDefaultValues = NonNullable<
  DeepPartial<WarehouseDirectSaleVariantsDetailFormSchemaType>['general']
>;

// The API stores ratios and margins as decimal values, the form shows percentages. A missing
// ratio means "no change", so it falls back to 1 (100 %), while a missing margin falls back to 0.
export function buildGeneralDefaultValues(
  general: GetDirectSaleVariantResponse['general'] | Nullish,
  branchId: string | Nullish
): GeneralDefaultValues {
  return {
    ...general,
    isActive: general?.isActive ?? false,
    // branchId is derived from the selected authorization profile, never from the variant itself.
    branchId: branchId ?? undefined,
    priceTypeRatio: decimalValueToPercentage(general?.priceTypeRatio ?? 1),
    rateTypeRatio: decimalValueToPercentage(general?.rateTypeRatio ?? 1),
    minimalMaterialMargin: decimalValueToPercentage(general?.minimalMaterialMargin ?? 0),
    minimalWorkMargin: decimalValueToPercentage(general?.minimalWorkMargin ?? 0),
    isUnitPriceWithVat: general?.isUnitPriceWithVat ?? false,
    isChangeableDefaultCustomer: general?.isChangeableDefaultCustomer ?? false,
  };
}
